import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

const ORDERED_GATE_TYPES = [
  'swing_gate',
  'double_leaf_gate',
  'sectional_gate',
  'roller_gate'
];

export default createSelector(
  constructionSelector,
  (construction) => {
    const gates = construction?.gates?.gates || [];
    const present = new Set(
      gates
        .map((g) => g?.type)
        .filter(Boolean)
    );

    // uporządkowana lista typów które występują w konfiguracji
    const gateTypesPresent = ORDERED_GATE_TYPES.filter((t) => present.has(t));

    return {
      loaded: construction.parameters_loaded,
      available: construction.available.gates_pressing,
      info: construction.info.gates_pressing,

      // ✅ tłumaczenia
      translations: construction.translations || {},

      // ✅ typy bram obecne w konfiguracji
      gateTypesPresent,

      // ✅ wybory per typ
      selectedByType: {
        swing_gate: construction.selected.gates_pressing_swing_gate,
        double_leaf_gate: construction.selected.gates_pressing_double_leaf_gate,
        sectional_gate: construction.selected.gates_pressing_sectional_gate,
        roller_gate: construction.selected.gates_pressing_roller_gate
      }
    };
  }
);
